import React, { useEffect, useState } from 'react'
import { UserProjectsSectionProps } from './UserProjectsSection.types'
import styles from './UserProjectsSection.module.scss'
import cl from 'classnames'
import {
  AutocompleteInput,
  H2,
  LabeledLine,
  NoneLabel,
  ProjectsTable,
  SectionContainer,
  Text1
} from 'components/shared'
import { ProjectDTO } from 'models'
import { useGetIsResponsiveScreen } from 'utilities'

const UserProjectsSectionComponent = (props: UserProjectsSectionProps) => {
  const {
    className,
    style,
    hasAssignedProjects,
    projectOptions,
    assignProject
  } = props

  const { isResponsive: isLargeMobile } = useGetIsResponsiveScreen('(max-width: 920px)')

  return (
    <SectionContainer
      style={{ marginTop: 20, ...style }}
      className={className}
      extraPaddingBottom={hasAssignedProjects}
    >
      <H2
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 10
        }}
      >
        Assigned projects
        {assignProject && (
          // <LabeledLine
          //   label='Assign a project'
          //   style={{ marginTop: 0 }}
          // >
          // </LabeledLine>
          <div className={cl(styles.flexRow, styles.justifyCenter, styles.alignCenter, styles.gap10, (isLargeMobile && styles.flexCol), (isLargeMobile && styles.alignStart))} style={{ marginTop: 0 }}>
            <Text1 overflowHidden={false} bold>
              Assign a project
            </Text1>
            <AutocompleteInput<ProjectDTO>
              placeholder='Select a project'
              style={{ width: 300, zIndex: 2 }}
              options={projectOptions}
              getOptionLabel={project => project.name}
              onOptionSelect={({ id }) => assignProject(id)}
            />
          </div>
        )}
      </H2>
      {hasAssignedProjects
        ? (
          <ProjectsTable
            noBoxShadow
            style={{
              marginTop: 23,
              minHeight: 200,
              maxHeight: 500,
              overflow: 'auto'
            }}
            isMyProfileRender={true}
          />
        )
        : (
          <NoneLabel
            label='No assigned projects yet.'
          />
        )}
    </SectionContainer>
  )
}

const UserProjectsSection = UserProjectsSectionComponent
export { UserProjectsSection }
